import React from "react";
import { motion } from "framer-motion";
import "./hero.css";

const Hero = () => {
  return (
    <section className="hero-section">
      <div className="hero-container">
        {/* Main Hero Content - Clean and Focused */}
        <motion.div
          className="hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          {/* Main Heading */}
          <motion.h1
            className="hero-heading"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            <span className="heading-line-1">Affordable Crypto Marketing.</span>
            <br />
            <span className="heading-line-2">Real Growth.</span>
          </motion.h1>

          {/* Subtext */}
          <motion.p
            className="hero-subtext"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
          >
            Charamy.org connects you directly with 400+ trusted KOLs and delivers
            exposure in the crypto space like no other.
          </motion.p>

          {/* CTA Button */}
          <motion.div
            className="hero-buttons"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.7 }}
          >
            <a href="#contact" className="btn-primary">Get Started</a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;

